import banner from '@/api/banner';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const initialState = () => {
  return {
    /** gnb 띠 배너 */
    menuBanner: null,
    /** 플랫폼 전환 영역 배너 */
    platformBanner: [],
  };
};

const getters = {
  isPlatformBannerValid(state) {
    return state['platformBanner'].length;
  },
  isMenuBannerValid(state) {
    return state.menuBanner;
  },
};

const mutations = {
  setMenuBanner(state, bannerResponse) {
    state.menuBanner = bannerResponse;
  },

  setPlatformBanner(state, bannerResponse) {
    state.platformBanner = bannerResponse;
  },
};

const actions = {
  async fetchMenuBanner({ commit, state }) {
    try {
      const response = await banner.getAdminStrapi();

      if (!response.data || !response.data.data) {
        state.menuBanner = null;
        return;
      }

      commit('setMenuBanner', response.data.data);
    } catch (e) {
      console.error(e);
      state.menuBanner = null;
    }
  },

  async fetchPlatformBanner({ commit, state }) {
    if (state.platformBanner.length) {
      return state.platformBanner;
    }

    try {
      const response = await banner.getPlatformBanner();

      if (!response.data || !response.data.data || !response.data.data?.platform_banners.length) {
        commit('setPlatformBanner', []);
        return [];
      }

      commit('setPlatformBanner', response.data.data.platform_banners);
      return response.data.data.platform_banners;
    } catch (e) {
      console.error(e);
      commit('setPlatformBanner', []);
      return [];
    }
  },
};

export default {
  namespaced: true,
  state: initialState,
  mutations,
  actions,
  getters,
  strict: process.env.NODE_ENV !== 'production',
};
